import store from "@/store"

export default {
    get mobilePhone() {
        return store.state.prove.mobilePhone
    },

    set mobilePhone(mobilePhone) {
        store.commit("prove/updateMobilePhone", mobilePhone)
    },

    get mobilePhoneLast4() {
        const mobilePhone = store.state.prove.mobilePhone
        if (mobilePhone && mobilePhone.length >= 4) {
            return mobilePhone.slice(-4)
        }
        return null
    },

    get ssnLast4() {
        return store.state.prove.ssnLast4
    },

    set ssnLast4(ssnLast4) {
        store.commit("prove/updateSsnLast4", ssnLast4)
    },

    get prefilledFields() {
        return store.state.prove.prefilledFields
    },

    set prefilledFields(prefilledFields) {
        store.commit("prove/updatePrefilledFields", prefilledFields)
    },

    hasPrefilledFields() {
        return store.state.prove.prefilledFields.length > 0
    }
}
